<template>
	<div>
		<div v-if="!status" class="row">
			<div class="col-7">
				<e-select
					id="status_selected"
					v-model="status_selected"
                    track-by="code"
					label="label"
					:placeholder="$t('monte.congelation.selectionnez_statut')"
					:selectedLabel="$t('global.selected_label')"
					:options="all_status"
					:multiple="true"
				>
					<template slot="noOptions">{{ $t('global.list_empty') }}</template>
				</e-select>
			</div>
			<div class="col-3">
				<e-select
					id="type_date"
					v-model="type_date"
                    track-by="code"
					label="label"
					:placeholder="$t('monte.congelation.selectionnez_type_date')"
					:selectedLabel="$t('global.selected_label')"
					:options="all_type_date"
				>
					<template slot="noOptions">{{ $t('global.list_empty') }}</template>
				</e-select>
			</div>
			<div class="col-2">
				<b-button variant="primary" block @click="load_expeditions">{{ $t('global.rechercher') }}</b-button>
			</div>
			<div class="col-12">
	            <DateRangeV2
            		v-if="type_date"
	                :start.sync="start_date"
	                :end.sync="end_date"
	                :dateSelect="true"
	                :periodToShow="['personalise','jour','mois','mois_dernier']"
	                :submitButton="false"
	            />
			</div>
		</div>

        <CustomTable
            id_table="semence_commande"
            ref="table"
            :items="expeditions"
            :busy.sync="table_busy"
            primaryKey="semenceexpedition_id"
            :hide_if_empty="true"
            :hrefsRoutes="config_table_hrefs"
            :externSlotColumns="['semenceexpedition_expedition_date', 'semenceexpedition_commentaire', 'demandeur.tiers_tags', 'destinataire.tiers_tags', 'destinataire.tiers_rs', 'commandes_destinataire', 'reintegrer_line_button']"
            :columsAdd="addColumns"
        >
        <!-- 
            :callback_one="prete_expedition_checkall"
            :callback_one_deselect="prete_expedition_decheckall"
             -->
            <template v-slot:[`custom-slot-cell(semenceexpedition_expedition_date)`]="{ data }">
            	{{ formatDate(data.semenceexpedition_expedition_date) }} ({{ $t('monte.congelation.pour_dans') }} {{ $t('global.J') }}{{ data.expedition_day }})
            </template>
           <template v-slot:[`custom-slot-cell(semenceexpedition_commentaire)`]="{ data }">
				<div style="background-color: orange; color: white; word-break: break-all;" v-html="data.semenceexpedition_commentaire"></div>
			</template>
            <template v-slot:[`custom-slot-cell(demandeur.tiers_tags)`]="{ data }">
				<span v-if="data.demandeur.tags.length > 0" class="tag-manage"> <span v-for="tag in data.demandeur.tags" :key="tag.tags_id" :style="'background-color:'+tag.tags_color" class="tags tags-table"></span> </span>
            </template>
            <template v-slot:[`custom-slot-cell(destinataire.tiers_tags)`]="{ data }">
				<span v-if="data.destinataire.tags.length > 0" class="tag-manage"> <span v-for="tag in data.destinataire.tags" :key="tag.tags_id" :style="'background-color:'+tag.tags_color" class="tags tags-table"></span> </span>
            </template>
            <template v-slot:[`custom-slot-cell(destinataire.tiers_rs)`]="{ data }">
            	<template v-if="data.semenceexpedition_destinataire">
            		<router-link :to="{ name: 'tiersFiche', params: {tiers_id: data.destinataire.tiers_id} }"><tiers-moral-icon :moral="data.destinataire.tiers_moral" />{{ data.destinataire.tiers_rs }}</router-link>
	            	<span v-if="data.commandes_destinataire[1] > 0"><br>{{ data.commandes_destinataire[1] }}  <font-awesome-icon :icon="['fal', 'envelope']" /></span>
	            	<span v-if="data.commandes_destinataire[2] > 0"><br>{{ data.commandes_destinataire[2] }}  <font-awesome-icon :icon="['fal', 'clock']" /></span>
	            	<span v-if="data.commandes_destinataire[3] > 0"><br>{{ data.commandes_destinataire[3] }}  <font-awesome-icon :icon="['far', 'box']" /></span>
	            	<span v-if="data.commandes_destinataire[4] > 0"><br>{{ data.commandes_destinataire[4] }}  <font-awesome-icon :icon="['far', 'box-check']" /></span>
	            	<span v-if="data.commandes_destinataire[5] > 0"><br>{{ data.commandes_destinataire[5] }}  <font-awesome-icon :icon="['far', 'truck-loading']" /></span>
            	</template>
            	<template v-else>
            		{{ data.semenceexpedition_destinataire_manuel }}<br>
            		{{ data.semenceexpedition_destinataire_manuel_firstname }} {{ data.semenceexpedition_destinataire_manuel_lastname }}<br>
            		{{ data.semenceexpedition_destinataire_manuel_adress }} {{ data.semenceexpedition_destinataire_manuel_postalcode }} {{ data.semenceexpedition_destinataire_manuel_town }}<br>
            		{{ data.semenceexpedition_destinataire_manuel_mail }} {{ data.semenceexpedition_destinataire_manuel_tel }}
            	</template>
            </template>
            <template v-slot:[`custom-slot-cell(reintegrer_line_button)`]="{ data }">
            	<a href="#" @click.prevent="setUpReintegrerLineExpedition(data)">{{ $t('monte.congelation.reintegrer_line') }}</a>
            </template>
        </CustomTable>

		<b-modal ref="modal-cancel" hide-footer>
			<template v-slot:modal-title>
				{{ $t('monte.congelation.confirm_cancel_expedition') }}
			</template>

			<template slot="default">
            	<b>{{ $t('monte.congelation.question_cancel_expedition') }}</b>

            	<div class="row">
            		<div class="col-12">
						<div class="col-12 form-group">
							<label for="commentaire">{{ $t("monte.congelation.commentaire") }}</label>
							<e-editor-froala
								identifier="commentaire_cancel"
								:placeholder="getTrad('monte.congelation.commentaire')"
								:content="commentaire"
								@change="updateCommentaire"
								:moreText="[ 'bold', 'italic', 'strikeThrough', 'underline', 'undo', 'redo', 'formatUL', 'formatOL', 'clearFormatting' ]"
							></e-editor-froala>
						</div>
            		</div>
            	</div>
            	<div class="row text-center mt-2">
            		<div class="col-12">
			            <b-button variant="primary" @click="confirmCancelExpeditions">
			                <font-awesome-icon v-if="processing_edit" :icon="['fal', 'spinner']" pulse class="mr-1"/><font-awesome-icon v-else :icon="['fal', 'save']" class="mr-1"/>{{ $t('modal.general.ok') }}
			            </b-button>
			            <b-button variant="secondary" class="ml-2" @click="closeModal">
			                <font-awesome-icon :icon="['far', 'times']" class="mr-1"/>{{ $t('modal.general.annuler') }}
			            </b-button>
			        </div>
            	</div>
			</template>
		</b-modal>

		<b-modal ref="modal-differe" hide-footer>
			<template v-slot:modal-title>
				{{ $t('monte.congelation.confirm_differe_expedition') }}
			</template>

			<template slot="default">
            	<b>{{ $t('monte.congelation.question_differe_expedition') }}</b>

            	<div class="row text-center mt-2">
            		<div class="col-12">
			            <b-button variant="primary" @click="confirmDiffereExpeditions">
			                <font-awesome-icon v-if="processing_edit" :icon="['fal', 'spinner']" pulse class="mr-1"/><font-awesome-icon v-else :icon="['fal', 'save']" class="mr-1"/>{{ $t('modal.general.ok') }}
			            </b-button>
			            <b-button variant="secondary" class="ml-2" @click="closeModal">
			                <font-awesome-icon :icon="['far', 'times']" class="mr-1"/>{{ $t('modal.general.annuler') }}
			            </b-button>
			        </div>
            	</div>
			</template>
		</b-modal>

		<b-modal ref="modal-enlevement" hide-footer>
			<template v-slot:modal-title>
				{{ $t('monte.congelation.demande_enlevement') }}
			</template>

			<template slot="default">
            	<div class="row">
            		<div v-if="expeditions_destinataire" class="col-12">
            			<b-alert variant="warning" show>
            				{{ $t("monte.congelation.expeditions_destinataire_warning") }}
            			</b-alert>
            		</div>
            		<div class="col-3">
            			<label for="sur_place" class="col-form-label">{{ $t("monte.congelation.sur_place") }}</label>
			            <b-form-checkbox id="sur_place" v-model="sur_place" />
            		</div>
            		<div class="col-9">
			            <label for="transporteur" class="col-form-label">{{ $t("monte.congelation.transporteur") }}</label>
			            <e-select
			                v-model="transporteur"
			                id="transporteur"
			                track-by="semencetransporteurs_id"
			                :placeholder="$t('monte.congelation.selectionnez_transporteur')"
			                :selectedLabel="$t('global.selected_label')"
			                :options="all_transporteurs"
			                label="semencetransporteurs_label"
			                :searchable="true"
			                :allow-empty="false"
			                :show-labels="false"
							:disabled="sur_place"
			            />
            		</div>
            		<div v-if="!enlevement_dose" class="col-12">
						<label for="cuve_transport">{{ $t("monte.stock_semence.cuve_transport") }} *</label>
						<e-select
							id="cuve_transport"
							v-model="cuve_selected"
							label="full_name"
							:placeholder="$t('monte.stock_semence.rechercher_categorie')"
							:selectedLabel="$t('global.selected_label')"
							:options="all_cuves"
							:searchable="true"
							:show-labels="false"
							:allow-empty="true"
							:sortable="false"
							:class="{ 'is-invalid': !cuve_selected }"
						>
							<template slot="option" slot-scope="props"><span :style="`padding-left: ${25 * (props.option.indent || 0) }px;`">{{ props.option.full_name }}</span></template>
						</e-select>
            		</div>
            		<div v-if="sur_place" class="col-12">
						<div class="form-group">
							<label for="modeltype_label">{{ $t('monte.congelation.model_mail_enlevement') }}</label>
							<e-select
								v-model="template"
								id="model_id"
								track-by="model_label"
								label="model_label"
								:placeholder="$t('horse.search_doc')"
								:deselectLabel="$t('global.press_enter_to_remove')"
								:selectedLabel="$t('global.selected_label')"
								:options="templates"
								:searchable="true"
								:show-labels="false"
							/>
						</div>
						<i>{{ $t('monte.congelation.model_message_mail_enlevement') }}</i>
					</div>
            		<div class="col-12 mt-2 text-center">
			            <b-button variant="primary" @click="confirmEnlevement" :disabled="disableConfirmButton">
			                <font-awesome-icon v-if="processing_edit" :icon="['fal', 'spinner']" pulse class="mr-1"/><font-awesome-icon v-else :icon="['fal', 'save']" class="mr-1"/>{{ $t('modal.general.ok') }}
			            </b-button>
			            <b-button variant="secondary" class="ml-2" @click="closeModal">
			                <font-awesome-icon :icon="['far', 'times']" class="mr-1"/>{{ $t('modal.general.annuler') }}
			            </b-button>
			        </div>
            	</div>
			</template>
		</b-modal>

		<b-modal ref="modal_edit_date" hide-footer>
			<template v-slot:modal-title>
				{{ $t('monte.congelation.edit_date_depart') }}
			</template>

			<template slot="default">
				<div class="row">
					<div class="col-12">
						<label for="date">{{ $t('monte.congelation.date_expedition') }}</label>
						<e-datepicker id="date" v-model="date_expedition" mode="date"></e-datepicker>
					</div>

            		<div class="col-12 mt-2 text-center">
			            <b-button variant="primary" @click="confirmEditDate">
			            	{{ $t('global.enregistrer') }} <font-awesome-icon v-if="processing_edit" :icon="['fal', 'spinner']" pulse class="mr-1"/><font-awesome-icon v-else :icon="['fal', 'save']" class="mr-1"/>
			            </b-button>
			        </div>
				</div>
			</template>
		</b-modal>

		<b-modal ref="modal_edit_norme" hide-footer>
			<template v-slot:modal-title>
				{{ $t('monte.congelation.erreur_norme_commande') }}
			</template>

			<template slot="default">
				<div class="row">
					<b-alert class="col-12" variant="warning" show>
						{{ $t('monte.congelation.expedition_same_norme') }}
					</b-alert>
					<div class="col-12">
						<label for="norme">{{ $t("monte.congelation.norme") }}</label>
						<e-select
							v-model="norme_selected"
							id="protocole_id"
							track-by="protocole_label"
							label="protocole_label"
							:placeholder="$t('monte.congelation.selectionner_protocole')"
							:selectedLabel="$t('global.selected_label')"
							:options="protocoles"
							:searchable="true"
							:show-labels="false"
							:group-select="false"
							:loading="load_protocoles"
						>
							<template slot="noOptions">{{ $t('global.list_empty') }}</template>
						</e-select>
					</div>

            		<div class="col-12 mt-2 text-center">
			            <b-button variant="primary" @click="confirmEditNorme">
			            	{{ $t('global.enregistrer') }} <font-awesome-icon v-if="processing_edit" :icon="['fal', 'spinner']" pulse class="mr-1"/><font-awesome-icon v-else :icon="['fal', 'save']" class="mr-1"/>
			            </b-button>
			        </div>
				</div>
			</template>
		</b-modal>

		<b-modal ref="modal-courrier" hide-footer>
			<template v-slot:modal-title>
				<template>
					{{ $t("monte.congelation.courrier_sortie_stock") }}
				</template>
			</template>

			<div class="row">
				<div class="col-12">
					<div class="form-group">
						<label for="modeltype_label">{{ $t('model.modeltype_label') }} *</label>
						<e-select
							v-model="template"
							id="model_id"
							track-by="model_label"
							label="model_label"
							:placeholder="$t('horse.search_doc')"
							:deselectLabel="$t('global.press_enter_to_remove')"
							:selectedLabel="$t('global.selected_label')"
							:options="templates"
							:searchable="true"
							:allow-empty="false"
							:show-labels="false"
							:loading="loading_courrier"
						/>
					</div>
				</div>
				<div class="col-12 text-center">
					<b-button class="mt-1 rounded-pill" variant="primary" @click="confirmPrint">{{ $t("global.print") }} <font-awesome-icon v-if="processing_edit" :icon="['fal', 'spinner']" pulse /><font-awesome-icon v-else :icon="['fal', 'file-alt']" /></b-button>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script type="text/javascript">
	import Congelation from "@/mixins/Congelation.js"
	import ShutterCongelation from "@/mixins/shutters-manager/Congelation.js"
    import Navigation from "@/mixins/Navigation.js"
	import Model from "@/mixins/Model.js"
	import StockSemence from "@/mixins/StockSemence.js"
    import { EventBus } from "EventBus"

	export default {
		name: 'CommandeList',
		mixins: [Congelation, ShutterCongelation, Navigation, Model, StockSemence],
		props: ['horse_id', 'status', 'demandeur_id', 'destinataire_id'],
		data () {
			return {
				table_busy: false,
				expeditions: [],
				config_table_hrefs: {
					'stallion.horse_nom': {
						routeUniqueName: 'StallionFiche',
						routeName: 'horseFiche',
						params: {
							horse_id: 'stallion.horse_id'
						}
					},
					'mare.horse_nom': {
						routeUniqueName: 'MareFiche',
						routeName: 'horseFiche',
						params: {
							horse_id: 'mare.horse_id'
						}
					},
					'demandeur.tiers_rs': {
						routeUniqueName: 'demandeurFiche',
						routeName: 'tiersFiche',
						params: {
							tiers_id: 'demandeur.tiers_id'
						}
					},
					'client.tiers_rs': {
						routeUniqueName: 'clientFiche',
						routeName: 'tiersFiche',
						params: {
							tiers_id: 'client.tiers_id'
						}
					}
				},
				events_tab: {
					'TableAction::goToAddExpedition': () => {
						this.setUpAddCommande(this.horse_id)
					},
					'TableAction::goToCancelExpedition': this.openConfirmCancel,
					'TableAction::goToDiffereExpedition': this.openConfirmDiffere,
					'TableAction::goToPrepareExpedition': this.goToPrepareExpedition,
					'TableAction::goToPretExpedition': this.checkPretExpedition,
					'TableAction::goToReintegrerExpedition': this.setUpReintegrerExpedition,
					'TableAction::goToEditExpedition': this.setUpEditExpedition,
					'TableAction::goToEditQuickExpedition': this.setUpEditQuickExpedition,
					'TableAction::goToDemenceEnlevement': this.openConfirmEnlevement,
					'TableAction::goToValidCommande': this.setUpValidCommande,
					'TableAction::goToEditDateDepart': this.openModalEditDateDepart,
					'TableAction::goToPdfSortieStock': this.openModalSortieStock
				},
				all_status: [{
					code: 0,
					label: this.getTrad('monte.congelation.status.cancel')
				},{
					code: 1,
					label: this.getTrad('monte.congelation.status.save')
				},{
					code: 2,
					label: this.getTrad('monte.congelation.status.accept')
				},{
					code: 3,
					label: this.getTrad('monte.congelation.status.en_cours')
				},{
					code: 4,
					label: this.getTrad('monte.congelation.status.ready')
				// },{
				// 	code: 5,
				// 	label: this.getTrad('monte.congelation.status.waiting')
				// },{
				// 	code: 6,
				// 	label: this.getTrad('monte.congelation.status.expedie')
				// },{
				// 	code: 7,
				// 	label: this.getTrad('monte.congelation.status.livre')
				// },{
				// 	code: 8,
				// 	label: this.getTrad('monte.congelation.status.facture')
				}],
				status_selected: [],
				all_type_date: [{
					code: 'semenceexpedition_expedition_date',
					label: this.getTrad('monte.congelation.date.semenceexpedition_expedition_date')
				},
				{
					code: 'semenceexpedition_inserted_date',
					label: this.getTrad('monte.congelation.date.semenceexpedition_inserted_date')
				}],
				type_date: null,
				start_date: new Date(new Date().setDate(new Date().getDate() - 7)),
				end_date: new Date(),
				expedition_edit: [],
				processing_edit: false,
				all_transporteurs: [],
				transporteur: null,
				sur_place: false,
				templates: [],
				template: null,
				expeditions_destinataire: 0,
				all_cuves: [],
				cuve_selected: null,
				commentaire: '',
				commentaire_cancel: '',
				commandes_edit_date: [],
				date_expedition: new Date(),
				norme_selected: null,
				protocoles: [],
				load_protocoles: false,
				loading_courrier: false
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.status_selected = this.all_status.filter(st => [1, 2].includes(st.code))
				if (this.horse_id){
					this.status_selected = this.all_status.filter(st => [1, 2, 3, 4].includes(st.code))
				}

				if(this.demandeur_id || this.destinataire_id) {
					this.all_status.push({
						code: 5,
						label: this.getTrad('monte.congelation.status.waiting')
					})
					this.status_selected = this.all_status.filter(st => [1, 2, 3, 4, 5].includes(st.code))
				}

				if(this.status && this.status.length > 0) {
					this.status_selected = this.all_status.filter(st => this.status.includes(st.code))
				}
				this.load_expeditions()
				this.all_transporteurs = await this.getAllTransporteurs()
			},

			async load_expeditions() {
				this.shutterPanel().keepOnlyGiven('commande-list')
				if(this.status_selected.length == 0) {
					return false
				}
				this.table_busy = true
				const expeditions = await this.getExpeditions(this.horse_id, this.status_selected.map(st => st.code), this.type_date, this.start_date, this.end_date, this.demandeur_id, this.destinataire_id)
				expeditions.forEach(exp => {
					exp.statut = this.getTrad('monte.congelation.status.'+exp.semenceexpedition_status)
					exp.semenceexpedition_qte += ' ' + (exp.semenceexpedition_dose ? this.getTrad('monte.doses') : this.getTrad('monte.paillettes'))
					exp.expedition_day = this.calculDifference(exp.semenceexpedition_expedition_date)
					if(!exp.destinataire) {
						exp.destinataire = {tags: [], tiers_rs: '.'}
					}
				})
				this.expeditions = expeditions
				this.table_busy = false
				if(this.$refs.table) {
					this.$refs.table.unselectAll()
				}
			},

			async openConfirmCancel(expeditions) {
				this.expedition_edit = expeditions
				this.commentaire_cancel = expeditions.length == 1 ? expeditions[0].semenceexpedition_commentaire : ''
				this.commentaire = expeditions.length == 1 ? expeditions[0].semenceexpedition_commentaire : ''
				this.$refs['modal-cancel'].show()
			},

			async confirmCancelExpeditions() {
				this.processing_edit = true
				
				await this.cancelExpedition(this.expedition_edit.map(exp => exp.semenceexpedition_id), this.commentaire_cancel)
				this.successToast('toast.info_save_succes')
				this.processing_edit = false
				this.$refs['modal-cancel'].hide()
				this.load_expeditions()
			},

			async openConfirmDiffere(expeditions) {
				this.expedition_edit = expeditions
				this.$refs['modal-differe'].show()
			},

			async confirmDiffereExpeditions() {
				this.processing_edit = true
				
				await this.differeExpedition(this.expedition_edit.map(exp => exp.semenceexpedition_id))
				this.successToast('toast.info_save_succes')
				this.processing_edit = false
				this.$refs['modal-differe'].hide()
				this.load_expeditions()
			},

			closeModal() {
				this.$refs['modal-cancel'].hide()
			},

			async goToPrepareExpedition(expeditions) {
				await this.prepareExpeditions(expeditions.map(exp => exp.semenceexpedition_id).join(','))
				EventBus.$emit('TableAction::stopSpin', true)
				this.successToast('toast.info_save_succes')
				this.load_expeditions()
			},

            prete_expedition_checkall(item) {
                if(item.length > 0 && item[0].semenceexpedition_status == 4) {
					const destinataire_id = item[0].semenceexpedition_destinataire
					const cuve_id = item[0].semenceexpedition_cuve
					const same_expedition = this.expeditions.filter(exp => exp.semenceexpedition_status == 4 && exp.semenceexpedition_destinataire == destinataire_id && exp.semenceexpedition_cuve == cuve_id)
					this.$refs.table.manual_check(same_expedition)
				}
            },

            prete_expedition_decheckall(item) {
                if(item.length > 0 && item[0].semenceexpedition_status == 4) {
					const destinataire_id = item[0].semenceexpedition_destinataire
					const cuve_id = item[0].semenceexpedition_cuve
					const same_expedition = this.expeditions.filter(exp => exp.semenceexpedition_status == 4 && exp.semenceexpedition_destinataire == destinataire_id && exp.semenceexpedition_cuve == cuve_id)
					this.$refs.table.manual_decheck(same_expedition)
				}
			},

			async openConfirmEnlevement(expeditions) {
				this.expedition_edit = expeditions
				this.template = null
				this.expeditions_destinataire = 0

				const all_localisations = await this.getLocalisationSemenceFullName()
				this.all_cuves = all_localisations.filter(loc => loc.semencelocalisation_transport && !loc.semencelocalisation_shipped && (!loc.semencelocalisation_destinataire || loc.semencelocalisation_destinataire == expeditions[0].semenceexpedition_destinataire))
				this.cuve_selected = this.all_cuves.find(loc => loc.semencelocalisation_id == expeditions[0].semenceexpedition_cuve)
				this.$refs['modal-enlevement'].show()
				this.loadAllModel(0, ['demande_enlevement']).then(res => {
					this.templates = res
				})
				this.getCommandeDestinataire(expeditions[0].semenceexpedition_destinataire, [1,2,3]).then(res => {
					this.expeditions_destinataire = res.length > 0
				})
				this.getExpeditionDestinataire(expeditions[0].semenceexpedition_destinataire).then(res => {
					if(!this.cuve_selected)
						this.cuve_selected = this.all_cuves.find(loc => loc.semencelocalisation_id == res.cuve)
					if(res.transporteur) 
						this.transporteur = this.all_transporteurs.find(trans => trans.semencetransporteurs_id == res.transporteur)
					else
						this.sur_place = true
					if(this.cuve_selected){
						this.cuve_selected.full_name += '- ' + this.getTrad('monte.congelation.en_cours_destinataire')
					}
				})
			},

			async confirmEnlevement() {
				this.processing_edit = true

				if(this.disableConfirmButton) {
					return false
				}

				const transporteur_id = !this.sur_place ? this.transporteur.semencetransporteurs_id : null
				const model_id = this.template ? this.template.model_id : null
				const cuve_id = !this.enlevement_dose ? this.cuve_selected.semencelocalisation_id : null
				
				await this.demandeEnlevement(this.expedition_edit.map(exp => exp.semenceexpedition_id), transporteur_id, model_id, cuve_id)
				await this.$sync.force(true, true)
				this.successToast('toast.info_save_succes')
				this.processing_edit = false
				this.$refs['modal-enlevement'].hide()
				this.load_expeditions()
				this.transporteur = null
				this.sur_place = false
			},

			calculDifference(date) {
				const date1 = new Date(date)
				const date2 = new Date()
				date1.setHours(0,0,0,0);
				date2.setHours(0,0,0,0);
				let Difference_In_Time = date2.getTime() - date1.getTime(); 
				let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24); 
				return Math.round(Difference_In_Days)*-1;
			},

			updateCommentaire(val) {
				this.commentaire_cancel = val.val
			},

			openModalEditDateDepart(commandes) {
				this.commandes_edit_date = commandes
				this.date_expedition = new Date(commandes[0].semenceexpedition_expedition_date)
				this.$refs['modal_edit_date'].show()
			},

			async confirmEditDate() {
				this.processing_edit = true
				const commandes_ids = this.commandes_edit_date.map(exp => exp.semenceexpedition_id)
				await this.editCommandesDate(commandes_ids, this.date_expedition.toDateInputValue())
				this.processing_edit = false
				this.successToast('toast.info_save_succes')
				this.$refs['modal_edit_date'].hide()
				this.load_expeditions()
			},

			async openModalSortieStock(commandes) {
				this.commandes_edit_date = commandes
				this.$refs['modal-courrier'].show()
				this.loading_courrier = true
				this.template = null
				this.templates = await this.loadAllModel(0, ['sortie_stock'])
				if(this.templates.length == 1) this.template = this.templates[0]
				this.loading_courrier = false
			},

			async confirmPrint() {
				this.processing_edit = true
				await this.printSortieStocks(this.commandes_edit_date.map(exp => exp.semenceexpedition_id), this.template.model_id, this.template.model_label)
				this.processing_edit = false
				this.$refs['modal-courrier'].hide()
			},

			async checkPretExpedition(expeditions) {
				if(expeditions.every(exp => exp.semenceexpedition_norme == expeditions[0].semenceexpedition_norme)) {
					this.setUpPreparationExpedition(expeditions)
				}
				else {
					this.$refs.modal_edit_norme.show()
					this.expedition_edit = expeditions
					this.norme_selected = null
					if(this.protocoles.length == 0) {
						this.load_protocoles = true
						this.protocoles = await this.getAllProtocoles()
						this.load_protocoles = false
					}
					if(expeditions[0].semenceexpedition_norme)
						this.norme_selected = this.protocoles.find(pro => pro.protocole_id == expeditions[0].semenceexpedition_norme)
				}
			},

			async confirmEditNorme() {
				this.processing_edit = true
				await this.editCommandesNorme(this.expedition_edit.map(exp => exp.semenceexpedition_id), this.norme_selected.protocole_id)
				this.successToast('toast.info_save_succes')
				this.processing_edit = false
				this.$refs.modal_edit_norme.hide()
				this.expedition_edit.forEach(exp => {
					exp.semenceexpedition_norme = this.norme_selected.protocole_id
				})
				this.setUpPreparationExpedition(this.expedition_edit)
			}
		},

		watch: {
			sur_place(val) {
				if(val) {
					this.transporteur = null
					const cuve = {semencelocalisation_id: 0, full_name: this.getTrad('monte.congelation.cuve_client')}
					this.all_cuves.unshift(cuve)
					if(!this.cuve_selected) {
						this.cuve_selected = cuve
					}
				}
				else {
					const index = this.all_cuves.findIndex(cuve => cuve.semencelocalisation_id == 0)
					this.all_cuves.splice(index, 1)
					this.cuve_selected = null
				}
			}
		},

		components: {
			CustomTable : () => import('GroomyRoot/components/Table/CustomTable'),
			DateRangeV2: () => import('GroomyRoot/components/Inputs/DateRangeV2')
		},

		computed: {
			disableConfirmButton() {
				return (this.transporteur == null && this.sur_place == false && !this.enlevement_dose) || (!this.enlevement_dose && !this.cuve_selected)
			},

			addColumns() {
				return this.$route.name == 'CongelationCommandePretExpedier' ? ['reintegrer_line_button'] : []
			},

			enlevement_dose() {
				return this.expedition_edit.every(exp => exp.semenceexpedition_dose)
			}
		}
	}

</script>